/**
 * Pure validation helpers for the SpaceBetweenBays width form field.
 * Lives outside the React component file so unit tests can import it without
 * pulling in MUI / Tolgee transitive dependencies.
 */

export const SBB_MIN_WIDTH = 0.1
export const SBB_MAX_WIDTH = 20

export type SbbValidationError = 'required' | 'belowMin' | 'aboveMax' | undefined

export const validateSpaceBetweenBaysWidth = (
  value: number | string | undefined | null,
): SbbValidationError => {
  if (value === '' || value === undefined || value === null) return 'required'
  const numeric = Number(value)
  if (Number.isNaN(numeric)) return 'required'
  if (numeric < SBB_MIN_WIDTH) return 'belowMin'
  if (numeric > SBB_MAX_WIDTH) return 'aboveMax'
  return undefined
}
